export default __webpack_public_path__ + "static/media/metamask-fox.7e842216.svg";